package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.ccab.casr.EngineIdentifiers
import com.neurobs.react.{GenericState, GenericStateGenerator, StateAttribute}
import com.neurobs.ccabserver.transcriptreview.util.TranscriptWord
import com.neurobs.util.TimeSeconds
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useState
import slinky.core.facade.ReactElement

case class TranscriptTableState (
  recordingTranscriptReviewState: RecordingTranscriptReviewState,
  decimalPlacePrecision: StateAttribute[Int]
                            ) extends GenericState {

  def roundedStartTime(word: TranscriptWord): TimeSeconds = word.roundedStartTime(decimalPlacePrecision.value)
  def roundedEndTime(word: TranscriptWord): TimeSeconds = word.roundedEndTime(decimalPlacePrecision.value)
}

object TranscriptTableStateGenerator extends GenericStateGenerator[TranscriptTableState] {

  override def generateEmptyDefaultState(): TranscriptTableState = {
    TranscriptTableState(
      RecordingTranscriptReviewStateGenerator.generateEmptyDefaultState(),
      emptyDefaultState(2)
    )
  }
}

@react
object TranscriptTableStateProvider {

  case class Props(children: ReactElement*)

  val component = FunctionalComponent[Props] { props =>

    val recordingTranscriptReviewState = RecordingTranscriptReviewStateGenerator.accessState

    val decimalPlacePrecisionState = StateAttribute(useState(2))

    val engineTableState = TranscriptTableState(
      recordingTranscriptReviewState,
      decimalPlacePrecisionState
    )

    TranscriptTableStateGenerator.Provider(engineTableState)(
      props.children:_*
    )
  }
}
